const tooltipsText = {
  // Projekt seznam
  PSProjektiClanice: "Projekti, v katerih sodeluje vaša članica.",
  PSProjektiOstali: "Ostali projekti UM (omejen dostop za vpogled v podatke)",
  PSProjektiGlobalno: "Vsi projekti",

  // Projekt details
  PDnaslovProjekta: "lorem ipsum21",

  // Splosno
  SplosnoObcanskaZnanost:
    "Občanska znanost je vključevanje javnosti (občanov raziskovalcev) v znanstvenoraziskovalno delo pod vodstvom raziskovalcev z namenom približevanja znanosti javnosti in odločevalcem, spodbujanja zanimanja za znanost, inovacije in tehnologijo ter omogočanja boljšega razumevanja znanstvenih odkritij in njihove vloge za družbo. Projekti izvajanja občanske znanosti se izvajajo v okviru javno (so)financiranih raziskav.\nStopnje udeležbe v občanski znanosti so množično prispevanje podatkov (Crowdsourcing), razporejena inteligenca (Distributed Intelligence), participativna znanost (Participatory Science) ali ekstremna državljanska znanost (Extreme Citizen Science).\nFaze, kjer so lahko državljani vključeni, so skladno z opredelitvijo programa Obzorje Evropa sooblikovanje raziskave, zbiranje podatkov, analiza in interpretacija ter diseminacija in uporaba rezultatov.",

  // Pogodba
  P2naslovPogodbe: "Vpišite celoten naslov in številko pogodbe.",
  P2stevilkaPogodbe: "lorem ipsum23",

  // Načrtovane vrednosti - celoten projekt
  P41vrednostProjekta:
    "Vpišite celotno vrednost projekta, izraženo v EUR na 2 decimalki.",
  P41vrednostSofinanciranjaIzProjektnihVirov:
    "Vpišite višino sofinanciranja iz projektnih virov, izraženo v EUR na 2 decimalki.",

  // Načrtovane vrednosti - UM skupaj
  P41vrednostProjektaZaUM:
    "Samodejni izpis vrednosti projekta za Univerzo v Mariboru, izražene v EUR na 2 decimalki.",
  P41vrednostSofinanciranjaIzProjektnihVirovZaUM:
    "Samodejni izpis višine sofinanciranja iz projektnih virov za Univerzo v Mariboru, izražene v EUR na 2 decimalki.",
  P41VrednostDelezLastnegaSofinanciranjaUM:
    "Samodejni izpis višine sofinanciranja projekta z lastnimi sredstvi Univerze v Mariboru, izražene v EUR na 2 decimalki. / Samodejni izpis deleža sofinanciranja projekta z lastnimi sredstvi Univerze v Mariboru, izraženega v % na 2 decimalki.",
  P41obsegZaposlitveFTE:
    "Samodejni izpis obsega zaposlitve v FTE za osebe, zaposlene na Univerzi v Mariboru v obdobju trajanja projekta.",

  // Načrtovane vrednosti - posamezna članica
  P41vrednostProjektaZaClanicoUM:
    "Vpišite vrednost projekta za članico Univerze v Mariboru, izraženo v EUR na 2 decimalki.",
  P41vrednostSofinanaciranjaIzProjektnihVirovZaClanicoUM:
    "Vpišite višino sofinanciranja iz projektnih virov za članico Univerze v Mariboru, izraženo v EUR na 2 decimalki.",
  P41vrednostDelezLastnegaSofinanciranjaUM:
    "Vpišite višino sofinanciranja projekta z lastnimi sredstvi za članico Univerze v Mariboru, izraženo v EUR na 2 decimalki. / Samodejni izpis deleža sofinanciranja projekta z lastnimi sredstvi za članico Univerze v Mariboru, izraženega v % na 2 decimalki.",
  P41obsegZaposlitveNaClaniciUM:
    "Vpišite obseg zaposlitve v FTE za osebe, zaposlene na članici Univerze v Mariboru v obdobju trajanja projekta.",

  // Realizirane vrednosti - celoten projekt
  P42vrednostProjekta:
    "Vpišite realizirano vrednost projekta, izraženo v EUR na 2 decimalki.",
  P42vrednostSofinanciranjaIzProjektnihVirov:
    "Vpišite višino realiziranega sofinanciranja iz projektnih virov, izraženo v EUR na 2 decimalki.",

  // Realizirane vrednosti - UM skupaj
  P42vrednostProjektaZaUM:
    "Samodejni izpis realizirane vrednosti projekta za Univerzo v Mariboru, izražene v EUR na 2 decimalki.",
  P42vrednostSofinanciranjaIzProjektnihVirovZaUM:
    "Samodejni izpis realizirane višine sofinanciranja iz projektnih virov za Univerzo v Mariboru, izražene v EUR na 2 decimalki.",
  P42VrednostDelezLastnegaSofinanciranjaUM:
    "Samodejni izpis realizirane višine sofinanciranja projekta z lastnimi sredstvi Univerze v Mariboru, izražene v EUR na 2 decimalki. / Samodejni izpis realiziranega deleža sofinanciranja projekta z lastnimi sredstvi Univerze v Mariboru, izraženega v % na 2 decimalki.",
  P42obsegZaposlitveFTE:
    "Samodejni izpis realiziranega obsega zaposlitve v FTE za osebe, zaposlene na Univerzi v Mariboru v obdobju trajanja projekta.",

  // Realizirane vrednosti - posamezna članica
  P42vrednostProjetaZaClanicoUM:
    "Vpišite realizirano vrednost projekta za članico Univerze v Mariboru, izraženo v EUR na 2 decimalki.",
  P42vrednostSofinanaciranjaIzProjektnihVirovZaClanicoUM:
    "Vpišite višino realiziranega sofinanciranja iz projektnih virov za članico Univerze v Mariboru, izraženo v EUR na 2 decimalki.",
  P42vrednostDelezLastnegaSofinanciranjaUM:
    "Vpišite realizirano višino sofinanciranja projekta z lastnimi sredstvi članice Univerze v Mariboru, izraženo v EUR na 2 decimalki. / Vpišite realizirani delež sofinanciranja projekta z lastnimi sredstvi članice Univerze v Mariboru, izražen v % na 2 decimalki.",
  P42obsegZaposlitveNaClaniciUM:
    "Vpišite realizirani obseg zaposlitve v FTE za osebe, zaposlene na članici Univerze v Mariboru v obdobju trajanja projekta.",
};

export default tooltipsText;
